import React from "react";
import { toast } from "react-toastify";
import Storage from "@/app/core/util/Storage";
import { useEffect, useState, useRef } from "react";
import GetBaseUrl from "@/app/core/base/BaseAddress";
import CopyToClipboard from "react-copy-to-clipboard";
import Translate, { Message } from "@/app/core/util/messages/GeralMessages";
import UserModal from "@/app/core/layouts/main-components/users/UserModal";
import { AccountController } from "@/app/core/base/controllers/AccountController";
import { UserStatusObj, UserStatusTranslate } from "@/app/core/util/helpers/UserHelper";

export default function CompanyComponent() {
    const userData = Storage.getUserData();
    const [users, setUsers] = useState([]);
    const [selected, setSelected] = useState({});
    const [showModal, setShowModal] = useState(false);

    useEffect(() => {
        loadCompanyUsers()
    }, []);

    async function loadCompanyUsers() {
        await AccountController.CompanyUsers(userData.companyId, res => {
            setUsers(res);
        })
    }

    async function removeUser(item) {
        if (item.id != userData.id) {
            if (window.confirm(Translate(Message.DeleteConfirm))) {

                AccountController.Delete(item.id, res => {
                    toast.success(Message.DeleteSuccess);
                    setTimeout(() => {
                        loadCompanyUsers();
                    }, 400);
                })
            }
        } else {
            toast.error("Você não pode excluir a própria conta");
        }
    }

    function approveUser(item) {
        if (window.confirm(Translate(Message.Confirm))) {
            AccountController.ApproveCompanyUser(item.id, UserStatusObj.Active, res => {
                toast.success(Translate(Message.Saved));
                loadCompanyUsers();
            })
        }
    }

    function showUser(item) {
        setSelected(item);
        setShowModal(true);
    }

    return (
        <div className="content row mt-3">
            <div className="col-md-12">
                <h3 className="text-muted"><i className="fa fa-arrow-left mr-1" /> Empresa</h3>
            </div>
            <div className="col-12 row">
                <div className="col-md-8">
                    <h2 className="content-heading font-w700">Usuários</h2>
                </div>
                <div className="col-md-4 text-right">
                    <CopyToClipboard
                        text={`${GetBaseUrl()}#/register/?companyId=${userData.companyId}`}
                        onCopy={() => toast.info("Copiado para a área de transferência")}>
                        <button
                            type="button"
                            class="btn btn-dual btn-sm ml-2"
                            title="copiar">
                            <i className="far fa-copy" /> Copiar convite
                        </button>
                    </CopyToClipboard>
                </div>
                <div className="col-md-12">
                    <table className="table table-hover table-striped">
                        <thead>
                            <tr>
                                <th>{Translate(Message.Name)}</th>
                                <th>E-mail</th>
                                <th>Status</th>
                                <th>Ações</th>
                            </tr>
                        </thead>
                        <tbody>
                            {users &&
                                users.map((item, index) => (
                                    <tr>
                                        <td>{item.firstName} {item.lastName}</td>
                                        <td>{item.email}</td>
                                        <td>{UserStatusTranslate(item.status)}</td>
                                        <td>
                                            {item && item.status != UserStatusObj.Active ?
                                                <button className="btn btn-dual btn-sm" onClick={() => approveUser(item)}>
                                                    <i className="si si-check" /> Aprovar
                                                </button>
                                                : ""}
                                            <button className="btn btn-dual btn-sm" onClick={() => showUser(item)}>
                                                <i className="fa fa-eye" />
                                            </button>
                                            <button className="btn btn-dual btn-sm" onClick={() => removeUser(item)}>
                                                <i className="si si-trash text-danger" />
                                            </button>
                                        </td>
                                    </tr>
                                ))}
                        </tbody>
                    </table>
                    {users.length === 0 ? (
                        <div className="col-12 text-center">
                            <h4 className="font-w700 text-dark">Nenhum usuário adicionado</h4>
                            <a
                                className="btn btn-info"
                                href="javascript:void(0)"
                                onClick={() => setShowModal(true)}
                            >
                                Adicionar cartão
                            </a>
                            <hr style={{ width: 60 }} />
                        </div>
                    ) : (
                        ""
                    )}

                </div>
            </div>
            <UserModal
                infos={selected}
                show={showModal}
                onHide={() => setShowModal(false) | loadCompanyUsers() | setSelected({})}
            />
        </div>
    )
}